import axios from "axios";

export const loginAffiliateAuthentication = async (CUIL) => {
  const url = window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';

  const data = JSON.stringify({
    cuil: CUIL
  });
  const config = {
    method: "POST",
    url: `http://${url}:4000/api/v1/boletaDigital/loginafiliado`,
    //url: "http://localhost:4000/api/v1/boletaDigital/loginafiliado",
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  try {
    const response = axios(config);
    return await response;
  } catch (error) {
    const { response } = error;
    return await response;
  }
};
